module.exports = __webpack_public_path__ + "4f8e07c43b1a9de43be4477ef8d1ce68.svg";